import React from 'react'
import { withFirebase } from '../../components/Fb'

// reactstrap components
import {
  Row,
  Col
} from 'reactstrap'
import TarmoServices from '../../components/Partners/TarmoServices'

// core components

class BuildingMaintenanceContainer extends React.Component {
  render () {
    return (
      <>
        <div className='content'>
          <Row>
            <Col md='12'>
              <TarmoServices />
            </Col>
          </Row>
          <Row>
            <Col md='12'>
            </Col>
          </Row>
        </div>
      </>
    )
  }
}

export default withFirebase(BuildingMaintenanceContainer)
